import { AUTH_STATUSES, AUTH_TOKEN_NAME, PROWEN_AUTH_NAME, PROWEN_AUTH_USER, REGISTER_USER_EMAIL } from '@/constants';
import { API_URLS, IN_APP_ROUTES } from '@/constants/urls';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';
import { getAccessToken, removeActiveCompset, storeAccessToken } from '@/helpers/localStorageHandlers';
import { apiClient } from '@/services/apiClient';
import { userServices } from '@/services/dashboard.service';
import { queryKeys } from '@/services/queryKeyFactory';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthContext = React.createContext(null);

function AuthProvider({ children }) {

    const [isAuthenticated, setIsAuthenticated] = useState(() => {

        const authToken = getAccessToken();
        if (authToken) {
            return {
                authStatus: true,
                status: null
            }
        }
        return {
            authStatus: false,
            status: null
        }

    });

    const { data: profileData, isLoading: isLoadingProfileData, isError: isErrorProfileData, isFetching: isFetchingProfileData } = useQuery({
        queryKey: queryKeys.me(),
        queryFn: userServices.getUserDetails,
        enabled: !!isAuthenticated?.authStatus
    })
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!profileData || isLoadingProfileData || isErrorProfileData) return;

        setIsAuthenticated({
            authStatus: true,
            status: String(profileData.status).toUpperCase()
        });
    }, [profileData, isLoadingProfileData, isErrorProfileData]);

    const navigate = useNavigate();
    function redirectUser(status) {
        switch (status) {
            case AUTH_STATUSES.registered:
                navigate(IN_APP_ROUTES.OTP_VERIFICATION);
                break;
            case AUTH_STATUSES.verified:
                navigate(IN_APP_ROUTES.PAYMENT);
                break;
            case AUTH_STATUSES.payment_done:
                navigate(IN_APP_ROUTES.COMPSET_PAGE);
                break;
            case AUTH_STATUSES.active:
                navigate(IN_APP_ROUTES.DASHBOARD);
                break;
            default:
                navigate(IN_APP_ROUTES.LOGIN_PAGE);
        }
    }

    function cleanUpAccount() {

        

        setIsAuthenticated({
            authStatus: false,
            status: null
        })

        removeActiveCompset();
        queryClient.clear();
        localStorage.removeItem(PROWEN_AUTH_USER);
        localStorage.removeItem(PROWEN_AUTH_NAME);
        localStorage.removeItem(REGISTER_USER_EMAIL);
        localStorage.removeItem(AUTH_TOKEN_NAME);
    }

    async function handleLogout() {

        try {

            await apiClient.get(API_URLS.LOGOUT)
            cleanUpAccount()
            window.location = IN_APP_ROUTES.LOGIN_PAGE

        } catch (error) {
            apiErrorHandler(error)
            cleanUpAccount()
            window.location = IN_APP_ROUTES.LOGIN_PAGE
        }

    }

    async function handleLogin(data) {

        cleanUpAccount()

        try {
            const access_token = data?.tokens?.access
            const userDetails = data?.user
            localStorage.setItem(PROWEN_AUTH_USER, JSON.stringify(userDetails));
            setIsAuthenticated({
                status: userDetails?.status,
                authStatus: true
            });


            if (access_token) {
                storeAccessToken(access_token)
                redirectUser(String(userDetails?.status).toUpperCase())
            }

        } catch (error) {
            // apiErrorHandler(error)
        }

    }


    const value = { profileData, isLoadingProfileData, isErrorProfileData, isAuthenticated, setIsAuthenticated, handleLogin, handleLogout, cleanUpAccount, isFetchingProfileData };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within AuthProvider");
    }
    return context
}

export default AuthProvider;